// src/modules/viewModelBuiders.js
import { DOCUMENT_TYPE, TRANSFORMATION_MAP, UPLOAD_MODE } from './workflowConfig';

const sanitizeDirectoryName = (selectedDirectory) => {
  if (!selectedDirectory) {
    return '默认项目';
  }

  const match = selectedDirectory.match(/——\s*([一-龥a-zA-Z0-9]+)/);
  if (match) {
    return match[1];
  }

  const cleaned = selectedDirectory.replace(/[^一-龥a-zA-Z0-9]/g, '');
  return cleaned || '默认项目';
};

export const buildUploadTitle = (state, deviceTypes) => {
  if (state.documentType === DOCUMENT_TYPE.DEVICE) {
    const device = deviceTypes.find((item) => item.value === state.deviceType);
    return `上传${device?.label || '设备文件'}`;
  }
  if (state.documentType === DOCUMENT_TYPE.STANDARD) {
    return '上传国家/国际标准';
  }

  if (state.documentType === DOCUMENT_TYPE.ENTERPRISE) {
    return '上传企业标准';
  }
};

export const buildProcessButtonText = (state) => {
  if (state.loading) {
    return '处理中...';
  }

  if ((state.documentType === DOCUMENT_TYPE.STANDARD || state.documentType === DOCUMENT_TYPE.ENTERPRISE) && state.uploadMode === UPLOAD_MODE.SINGLE) {
    return '识别单页 →';
  }

  return state.documentType === DOCUMENT_TYPE.DEVICE ? '处理校准数据 →' : '提取目录并继续 →';
};

export const buildResultSummary = (state, deviceInfo) => {
  // 【新增】过滤掉没有实际数据行(rows)的空表格
  const validTables = state.tables?.filter(table =>
    table && Array.isArray(table.rows) && table.rows.length > 0
  ) || [];

  let tableCount = 0;

  if (state.documentType === DOCUMENT_TYPE.DEVICE) {
    tableCount = validTables.length;
  } else {
    // 标准/企业标准模式，统计有效表格数
    tableCount = validTables.length;
  }

  return state.documentType === DOCUMENT_TYPE.DEVICE
    ? `${deviceInfo?.label}校准数据（共 ${tableCount} 个方向）`
    : `共 ${tableCount} 个表格`;
};

export const buildInfoItems = (state, deviceInfo) => {
  if (state.documentType === DOCUMENT_TYPE.DEVICE) {
    return [
      ...(state.selectedDirectory ? [{ label: '测试项目', value: state.selectedDirectory }] : []),
      { label: '设备类型', value: deviceInfo?.label },
      { label: '处理规则', value: deviceInfo?.desc },
      ...(state.deviceType !== 'receiving_antenna' && state.tables[0]?.metadata?.note
        ? [{ label: '处理说明', value: state.tables[0].metadata.note }]
        : [])
    ];
  }

  const isSinglePage = state.uploadMode === UPLOAD_MODE.SINGLE;
  const selectedProject = state.selectedDirectory || state.selectedSinglePageDirectory;
  const availableLevels = Object.entries(state.carTablesByLevel || {})
    .filter(([, tables]) => Array.isArray(tables) && tables.some((table) => Array.isArray(table?.rows) && table.rows.length > 0))
    .map(([level]) => level);
  const shouldShowLevelInfo = availableLevels.length > 0 || (Array.isArray(state.tables) && state.tables.length > 0);
  return [
    ...(selectedProject ? [{ label: '测试项目', value: selectedProject }] : []),
    { label: '文档类型', value: isSinglePage ? '车辆EMC单页数据' : '车辆EMC测试报告' },
    ...((state.documentType === DOCUMENT_TYPE.STANDARD || state.documentType === DOCUMENT_TYPE.ENTERPRISE) && shouldShowLevelInfo
      ? [{ label: '等级', value: state.selectedLevel }]
      : []),
  ];
};

export const buildExportFileName = (state, deviceTypes) => {
  const transform = TRANSFORMATION_MAP[state.currentTransformationType] || TRANSFORMATION_MAP.original;
  const suffix = `-${transform.suffix}`;

  if (state.documentType === DOCUMENT_TYPE.DEVICE) {
    const device = deviceTypes.find((item) => item.value === state.deviceType);
    return `设备校准-${device?.label || '设备'}${suffix}`;
  }

  const standardPrefix = state.documentType === DOCUMENT_TYPE.ENTERPRISE
    ? '车辆企业标准'
    : '车辆国标国际标准';
  const directoryPart = sanitizeDirectoryName(state.selectedDirectory);
  return `${standardPrefix}-${directoryPart}${suffix}`;
};